export default __webpack_public_path__ + "icon-edit.png?26915fc150ee621041ec9ff1ce61c90a";